const context = require.context(
  "../../../../src/",
  true,
  /\/i18n\/he.json$/
);

export default context.keys().reduce((messages, path) => {
  return Object.assign(messages, context(path));
}, {});
